import { createReducer } from '@reduxjs/toolkit';
import { SET_SENTENCE } from '../actions/DaysSentenceActions';

const initialState = {
    sentenceData: {},
};

const daysSentence = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_SENTENCE, (state, action) => {
            state.sentenceData = action.data;
        });
});

export default daysSentence;
